import React, { useState } from 'react';
import * as pApi           from 'pursuit/api/pursuitApi';
import { toastr }          from 'react-redux-toastr'

export default function ContactForm() {
    const [fullName, setFullName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [message, setMessage] = useState('');

    let fullNameInput = null;
    let emailInput = null;
    let phoneInput = null;
    let messageInput = null;

    const doSubmit = () => {
        let isOk = true;
        let requiredFields = {
            fullName: {
                label: 'Full Name',
                input: fullNameInput,
                value: fullName,
            },
            email:    {
                label: 'Email',
                input: emailInput,
                value: email,
            },
            message:  {
                label: 'Message',
                input: messageInput,
                value: message
            },
        };

        toastr.removeByType('warning');

        Object.keys(requiredFields).map((field, key) => {
            if (requiredFields[field].value == '') {
                toastr.warning(
                    'Oops!',
                    'Your '+requiredFields[field].label+' is required before we can send your contact.'
                );

                requiredFields[field].input.focus();

                isOk = false;
            }
        });

        if (pApi.validEmail(email) === false) {
            toastr.warning(
                'Oops!',
                'The entered email address doesn\'t appear to be valid.'
            );

            emailInput.focus();

            isOk = false;
        }

        if (isOk === false) {
            return false;
        }

        pApi.submitContact({
            fullName: fullName,
            email: email,
            phone: phone,
            message: message,
        })
            .then(response => {
                if (response === true) {
                    setFullName('');
                    setEmail('');
                    setPhone('');
                    setMessage('');
                }
            });
    };

    return (
        <section role="contact">
            <article className="contact-form minor-padding--top--bottom">

                <div className="grid-center">
                    <div className="col-12">
                        <input type="text"
                            placeholder="Full Name *"
                            onChange={event => setFullName(event.target.value)}
                            value={fullName}
                            ref={input => fullNameInput = input}
                        />
                    </div>
                    <div className="col-6_xs-12">
                        <input type="text"
                            placeholder="Email *"
                            onChange={event => setEmail(event.target.value)}
                            value={email}
                            ref={input => emailInput = input}
                        />
                    </div>
                    <div className="col-6_xs-12">
                        <input type="text"
                            placeholder="Phone"
                            onChange={event => setPhone(event.target.value)}
                            value={phone}
                            ref={input => phoneInput = input}
                        />
                    </div>
                    <div className="col-12">
                        <textarea
                            placeholder="Your Message *"
                            onChange={event => setMessage(event.target.value)}
                            value={message}
                            ref={input => messageInput = input}
                        ></textarea>
                    </div>
                    <div className="col-12 justify-center">
                        <div className="minor-padding--top">
                            <div
                                className="button"
                                onClick={doSubmit}
                            >
                                Send Your Message
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </section>
    )
}
